// removed by extract-text-webpack-plugin
module.exports = {"featurename":"_1T5Ju"};


//////////////////
// WEBPACK FOOTER
// ./src/views/FeatureToggle/columns.scss
// module id = 787
// module chunks = 0